/**
 * The mark a value carries until a person confirms it.
 *
 * Ingested data is usable the moment it lands — grids, reports and the dossier
 * show it — but nothing says whether anyone has vouched for it. This is that
 * word, drawn like the pipeline's `calc` tag (`DerivedTag`): small, beside the
 * value, with its basis on hover, and never a reason to hide or withhold the
 * figure. It marks; it does not gate.
 *
 * Amber, because pending is work somebody owes — not an error (red) and not a
 * platform computation (violet).
 */

/** Why a value is pending, in a sentence — the hover text. */
export function pendingTitle(basis?: string | null): string {
  const reason = (basis ?? '').trim()
  return reason
    ? `Pending — no person has confirmed this value yet. ${reason}`
    : 'Pending — no person has confirmed this value yet. It is on the deal and in use; confirming records who and when.'
}

export function PendingMark({
  basis,
  className = '',
}: {
  /** Where the value came from, if known: "Stated in Term Sheet.pdf · p.2". */
  basis?: string | null
  className?: string
}) {
  return (
    <span
      title={pendingTitle(basis)}
      data-confirmation="pending"
      className={`ml-1 shrink-0 rounded border border-amber-300/30 bg-amber-300/10 px-1 text-[9px] font-medium uppercase tracking-wide text-amber-300 ${className}`}
    >
      pending
    </span>
  )
}

export default PendingMark
